import { nextTick, onBeforeUnmount, onMounted } from 'vue'

const getDomElement = (el) => {
  let element = el && el.value !== undefined ? el.value : el
  return element?.$el ?? element
}

const useIntersecting = (
  el,
  clb = _defaultClb,
  { offset = 0, immediate = true } = {}
) => {
  // Built on first use, not here. A composable body runs inside setup(), and
  // setup() also runs on the server, where IntersectionObserver does not
  // exist. Constructing it eagerly threw a ReferenceError that took down the
  // entire server render, so the page fell back to the empty SPA shell — no
  // error, just silently no SSR. Every caller of observe() is client-side.
  let observer

  const _observer = () => {
    observer ??= new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (!isIntersecting) return

          observer.unobserve(target)
          clb()
        })
      },
      {
        rootMargin: `${offset}px`
      }
    )
    return observer
  }

  const observe = async () => {
    await nextTick()
    try {
      const element = getDomElement(el)
      if (element) {
        _observer().observe(element)
      } else {
        console.error('No valid DOM element to observe', el)
      }
    } catch (error) {
      console.error('Error observing element', error)
    }
  }

  onMounted(async () => {
    if (!immediate) return

    await nextTick()
    observe()
  })

  onBeforeUnmount(() => {
    observer?.disconnect()
  })

  return { observe }
}

const _defaultClb = () => {
  console.warn('Please pass a valid callable')
}

export { useIntersecting }
